import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/inventoryStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class InventoryStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

InventoryStrategy.title = actions.title
const option = {
  value: 'update_inventory',
  display: 'Update Inventory',
  category: 'inventory',
  Component: InventoryStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
InventoryStrategy.option = option
